/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSmallJet = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m11.72 2 .48.64.32 1.12v3.52h.64l.16 1.76 3.2 3.84h.16l1.92 2.24v1.6l-5.44-1.12-.16 1.92-.32.16-.32 1.12 2.56 2.4v.64l-2.88-.32V22h-.48v-.48l-2.88.32v-.64l2.56-2.4-.32-1.12-.32-.16-.16-1.92L5 16.72v-1.44l1.92-2.4h.16l3.2-3.84V7.28h.64l.16-2.08V3.76l.32-1.12z" /></svg>;
export default SvgSmallJet;